export const initialState = () => ({
  billingAddress: {
    isSameAddress: true,
    cep: "",
    address: "",
    neighborhood: "",
    city: "",
    state: "",
    number: "",
    noNumber: false,
    complements: [""],
    noComplement: false,
    addressNote: ""
  }
})
